//
// TODO: En el futuro deberíamos refactorizar nuestras UIs para que hagan uso de
// un data router para poder usar el componente `ScrollRestoration` que viene
// con react-router-dom.
//
// Ver:
// * https://reactrouter.com/en/main/components/scroll-restoration
// * https://reactrouter.com/en/main/routers/picking-a-router
//

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollRestoration = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};

export default ScrollRestoration;
